export enum ChildSecurityStatus {
  SAFE = 'safe',
  WARNING = 'warning',
  COMPROMISED = 'compromised',
}

export enum ChildGender {
  MALE = 'male',
  FEMALE = 'female',
}

export enum ChildSort {
  NAME = 'name',
  SECURITY_STATUS = 'status',
}
